import type { Tournament } from './types.js';

/** Deterministische IDs über Zähler im Zustand — Replay erzeugt dieselben IDs. */
export function nextId(t: Tournament, prefix: string): string {
  const n = (t.counters[prefix] ?? 0) + 1;
  t.counters[prefix] = n;
  return `${prefix}${n}`;
}
